import script from "./AdminLinkRouter.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminLinkRouter.vue?vue&type=script&setup=true&lang=js"

import "./AdminLinkRouter.vue?vue&type=style&index=0&id=941bb218&scoped=true&lang=css"

import exportComponent from "C:\\Users\\jhunr\\Documents\\Work\\GCM3\\repos\\talentsage2026_previous\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-941bb218"]])

export default __exports__